"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgFilm = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M31.82 13A3.18 3.18 0 0135 16.18v15.64A3.18 3.18 0 0131.82 35H16.18A3.18 3.18 0 0113 31.82V16.18A3.18 3.18 0 0116.18 13h15.64zM18 30h-3v1.82c0 .652.528 1.18 1.18 1.18H18v-3zm10-5h-8v8h8v-8zm5 5h-3v3h1.82A1.18 1.18 0 0033 31.82V30zm0-5h-3v3h3v-3zm-15 0h-3v3h3v-3zm0-5h-3v3h3v-3zm10-5h-8v8h8v-8zm5 5h-3v3h3v-3zm-1.18-5H30v3h3v-1.82A1.18 1.18 0 0031.82 15zM18 15h-1.82A1.18 1.18 0 0015 16.18V18h3v-3z",
    id: "film_svg__a"
  }));
};

var _default = SvgFilm;
exports.default = _default;